/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react'
import { exceptThisSymbols } from '../../config'
export default function Input(
    {type,
        state,
        id,
        handleInput,
        submitSelected,
        setsubmitSelected,
        className,
        text,
        disable,
        maxLength,
        customError,
        optional,
        test_id,
        setcustomError,
        showErrorBorder,
        isMandatoryField,
        inputWidth,
        isAmountField,
        placeholder}) {

    return (
        <>
            <input 
                type={"text"}
                noValidate
                id={id}
                data-test-id = {test_id}
                title=""
                autoComplete='off'
                maxLength={maxLength ? maxLength : ''}
                onInput={(e) => { (id === 'pincode' || id === "poc_mobile_number"  || id === 'pin_code' || id === 'mobile_number' || id === 'emergency_contact_mobile_number' || id ==='father_mobile_number' || id ==='mother_mobile_number') || id === "student_aadhar_number" || id === "father_aadhar_number" || id === "mother_aadhar_number" ? e.target.value = e.target.value.replace(/\D/g, '') : (id === "student_aadhar_number" || id === "father_aadhar_number" || id === "mother_aadhar_number") ? e.target.value = e.target.value.replace(/^[0-9]+$/, '') : '' }}
                value={state[id]}
                pattern={type==='number'?"[0-9]{10}":"[^\s]+"}
                onKeyDown={e => {
                    if(e.keyCode===13)e.preventDefault()
                    if(type==='number'){
                        exceptThisSymbols.includes(e.key) && e.preventDefault();
                    }else if(e.key===' ' && state[id]===''){
                        e.preventDefault()
                    }
                }}
                disabled={disable}
                onInvalid={(e)=>e.preventDefault()}
                onChange={(e)=>{
                    if(type==='number'){
                        e.target.value.replace('-','')
                        if(/^\d*$/.test(e.target.value) || e.target.value !=='-'){
                            handleInput(e)
                        }
                    }else{
                        handleInput(e)
                    }}}
                onFocus={(e)=>{
                    setsubmitSelected(false);
                    if(setcustomError){
                        setcustomError([])
                    }

                    if (isAmountField === true) {
                        if (Number(e.target.value) === 0) {
                            e.target.value = '';
                            handleInput(e);
                        }
                    }
                }}

                onBlur={(e)=>{
                    if (isAmountField === true) {
                        let value = e.target.value;
                        if (value.trim() === '') {
                            value = 0;
                        }                        
                        value = parseFloat(value).toFixed(2);
                        e.target.value = value;
                        handleInput(e);
                    }
                }}
                className={`${(inputWidth !== undefined && inputWidth !== '') ? inputWidth : 'w-full'} inpt-fld ${(isMandatoryField!=undefined && isMandatoryField === true) ? 'error_border' : ''} ${showErrorBorder == true ? 'redBorder' : ''} ${submitSelected!= undefined && submitSelected && state[id] === '' && optional === undefined || ((customError !== undefined && customError?.includes(id)) && submitSelected && state[id] !== '') ? 'redBorder' : ''} `} placeholder={placeholder} />
            {/*Check the usage and remove error_border check if not required-Anitha*/}
            
            {/* {(submitSelected&& state[id] === '' &&optional===undefined)&&
                <ErrorMessage
                    message={text}
                    classKey="text-f1 font-normal text-[#F04438] add-error2 pt-1.5"
                    error
                />} */}
        </>

    )
}